import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { Maybe } from '../../../../../types/common';
import { SubscriptionType } from '../types';

interface ManagerStore {
  activeWatch: any;
  viewActions: boolean;
  isError: boolean;
  errorCode: any;
  buttonDisabled: boolean;
  confirmCancel: boolean;
  actionSucceeded: boolean;
  actionLoading: boolean;
  currentAction: string;
  termsAndConditions: boolean;
  // Persisted for the session so the manage view can branch linked vs paired.
  // Defaults to 'paired' for backward compatibility when the attribute is absent.
  subscriptionType: SubscriptionType;
}

const initialValues = {
  activeWatch: null,
  viewActions: false,
  isError: false,
  errorCode: null,
  buttonDisabled: false,
  confirmCancel: false,
  actionSucceeded: false,
  actionLoading: false,
  currentAction: '',
  termsAndConditions: false,
  subscriptionType: 'paired',
} as ManagerStore;

type Store = {
  managerValues: typeof initialValues;
  setManagerValues: (newValues: Partial<typeof initialValues>) => void;
  setManagerTermsAndConditions: (newValue: boolean) => void;
  setManagerActiveWatch: (watch: any) => void;
  resetManagerValues: () => void;
};

export const useWatchManagerStore = create<Store>()(
  devtools(
    set => ({
      managerValues: initialValues,
      setManagerValues: newValues => {
        set(
          state => ({
            managerValues: { ...state.managerValues, ...newValues },
          }),
          false,
          'watchManagerStore/setUserflowValues',
        );
      },
      setManagerTermsAndConditions: newValue => {
        set(
          state => ({
            managerValues: {
              ...state.managerValues,
              termsAndConditions: newValue,
            },
          }),
          false,
          'watchManagerStore/toggleTermsAndConditions',
        );
      },
      setManagerActiveWatch: newValue => {
        set(
          state => ({
            managerValues: {
              ...state.managerValues,
              viewActions: true,
              activeWatch: newValue,
            },
          }),
          false,
          'watchManagerStore/setManagerActiveWatch',
        );
      },
      resetManagerValues: () => {
        set(
          state => ({
            managerValues: initialValues,
          }),
          false,
          'watchManagerStore/resetManagerValues',
        );
      },
    }),
    {
      name: 'watchManagerStore',
      enabled: false,
    },
  ),
);
